import {
	VENTAS_POR_CLIENTES_REQUEST,
	VENTAS_POR_CLIENTES_RESPONSE,
	VENTAS_POR_CLIENTES_FAILURE,
	EXISTENCIA_COMERCIAL_REQUEST,
	EXISTENCIA_COMERCIAL_RESPONSE,
	EXISTENCIA_COMERCIAL_FAILURE,
	VENTAS_POR_DEPARTAMENTO_REQUEST,
	VENTAS_POR_DEPARTAMENTO_RESPONSE,
	VENTAS_POR_DEPARTAMENTO_FAILURE,
	VENTAS_POR_DEPARTAMENTO_DETALLADO_REQUEST,
	VENTAS_POR_DEPARTAMENTO_DETALLADO_RESPONSE,
	VENTAS_POR_DEPARTAMENTO_DETALLADO_FAILURE,
	VENTAS_POR_REGION_REQUEST,
	VENTAS_POR_REGION_RESPONSE,
	VENTAS_POR_REGION_FAILURE
} from './actions';

const ventas_por_cliente_InitialState = {
	ventascliente: [],
	error: null,
	isLoading: false
};
export const ventascliente = (state = ventas_por_cliente_InitialState, action) => {
	switch (action.type) {
		case VENTAS_POR_CLIENTES_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case VENTAS_POR_CLIENTES_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				ventascliente: action.ventascliente
			};
		case VENTAS_POR_CLIENTES_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const existencia_comerical_InitialState = {
	existencia_comercial: [],
	error: null,
	isLoading: false
};
export const existencia_comercial = (state = existencia_comerical_InitialState, action) => {
	switch (action.type) {
		case EXISTENCIA_COMERCIAL_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case EXISTENCIA_COMERCIAL_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				existencia_comercial: action.existencia_comercial
			};
		case EXISTENCIA_COMERCIAL_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const venta_departamento_InitialState = {
	venta_departamento: [],
	error: null,
	isLoading: false
};
export const venta_departamento = (state = venta_departamento_InitialState, action) => {
	switch (action.type) {
		case VENTAS_POR_DEPARTAMENTO_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case VENTAS_POR_DEPARTAMENTO_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				venta_departamento: action.venta_departamento
			};
		case VENTAS_POR_DEPARTAMENTO_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const venta_departamento_detalle_InitialState = {
	venta_departamento_detalle: [],
	error: null,
	isLoading: false
};
export const venta_departamento_detalle = (state = venta_departamento_detalle_InitialState, action) => {
	switch (action.type) {
		case VENTAS_POR_DEPARTAMENTO_DETALLADO_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case VENTAS_POR_DEPARTAMENTO_DETALLADO_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				venta_departamento_detalle: action.venta_departamento_detalle
			};
		case VENTAS_POR_DEPARTAMENTO_DETALLADO_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};

const venta_por_region_InitialState = {
	venta_region: [],
	error: null,
	isLoading: false
};
export const venta_region = (state = venta_por_region_InitialState, action) => {
	switch (action.type) {
		case VENTAS_POR_REGION_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case VENTAS_POR_REGION_RESPONSE:
			return {
				...state,
				isLoading: false,
				error: null,
				venta_region: action.venta_region
			};
		case VENTAS_POR_REGION_FAILURE:
			return {
				...state,
				isLoading: false,
				error: action.error
			};
		default:
			return state;
	}
};
